"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_1 = require("./styled");

var ActionInput =
/** @class */
function (_super) {
  __extends(ActionInput, _super);

  function ActionInput(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = function (event) {
      var input = event.target;
      var value = input.value;
      var id = _this.props.id;

      _this.setState({
        value: value
      }, function () {
        var onChange = _this.props.onChange;

        if (onChange) {
          onChange({
            id: id,
            value: value
          });
        }
      });
    };

    _this.onFocus = function () {
      _this.setState({
        isOnFocus: true
      });
    };

    _this.onBlur = function () {
      _this.setState({
        isOnFocus: false
      });
    };

    _this.renderAddon = function (addon) {
      return react_1.default.createElement(styled_1.Addon, null, addon);
    };

    var value = _this.props.value;
    _this.state = {
      isOnFocus: false,
      value: value || ''
    };
    return _this;
  }

  ActionInput.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        _b = _a.type,
        type = _b === void 0 ? 'text' : _b,
        isValid = _a.isValid,
        placeholder = _a.placeholder,
        disabled = _a.disabled,
        autoComplete = _a.autoComplete,
        addonBefore = _a.addonBefore,
        addonAfter = _a.addonAfter,
        required = _a.required;
    var _c = this.state,
        value = _c.value,
        isOnFocus = _c.isOnFocus;
    return react_1.default.createElement(styled_1.Wrapper, {
      isOnFocus: isOnFocus,
      isValid: isValid,
      className: "input-wrapper "
    }, addonBefore && this.renderAddon(addonBefore), react_1.default.createElement(styled_1.Input, {
      id: id,
      name: id,
      isValid: isValid,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onChange: this.onChange,
      disabled: disabled,
      placeholder: placeholder,
      type: type,
      autoComplete: autoComplete,
      value: value,
      required: required !== undefined ? required : true
    }), addonAfter && this.renderAddon(addonAfter));
  };

  ActionInput.defaultProps = {
    value: '',
    isValid: undefined
  };
  return ActionInput;
}(react_1.PureComponent);

exports.ActionInput = ActionInput;
exports.default = ActionInput;